module.exports = JSON.parse('{"Copied":"Скопировано","Failed to copy":"Ошибка при копировании"}')